import apiServices from '@/shared/services/api/axios'
const MyPageAdvisorServices = {
    apiGetAdvisorMyPage() {
        return apiServices.get('/tax-advisor/my-page')
    }
}
export default MyPageAdvisorServices
